<div class="row closing_section">
  <div class="col-md-12">
    <div class="srch_tabs" *ngIf="add_closing_res_length != 0">
      <div class="srch_here">
        <h5> Search </h5>
        <input type="text" class="form-control" [(ngModel)]="search">

      </div>
    </div>

    <nz-tabset nzType="card">
      <nz-tab *ngFor="let mont of add_closing_res" [nzTitle]="mont.month">
        <div class="table-responsive table_contact">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Date</th>
                <th scope="col">Name</th>
                <th scope="col">Position</th>
                <th scope="col">Company</th>
                <th scope="col">Salary</th>
                <th scope="col">Starting Date</th>
                <th scope="col">Admin</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let list of mont.data | closingListingPipe:search; let i = index;">
                <td>{{ i + 1 }}</td>
                <td>{{list.created * 1000 | date:'medium'}}</td>
                <td>{{list.name}}</td>
                <td>{{list.position}}</td>
                <td>{{list.company}}</td>
                <td>{{list.salary}}</td>
                <td>{{list.startingDate}}</td>
                <td>{{list.user.userName}}</td>
                <td>
                  <div class="action_td">
                    <a class="arrw" (click)="edit_closing_modal(edit_closing_modal_popup, list)"> <i
                        class="fas fa-star"></i></a>
                    <a class="cross" (click)="openModalDelete(deleteModal, list)"> X </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </nz-tab>
    </nz-tabset>
  </div>
</div>

<ng-template #edit_closing_modal_popup let-modal>
  <!-- Modal content-->
  <div class="modal-content">
    <button type="button" class="close close_modal" style="outline: none;" (click)="modal.dismiss('Cross click')"
      data-dismiss="modal"><span aria-hidden="true">×</span></button>
    <div class="modal-body p-4">
      <div class="row">
        <div class="col-md-12">
          <div class="sction_new">
            <div class="search_done ">
              <h2 class="title text-center mb-5"> Edit Form </h2>
            </div>
            <div class="search_done text-left">
              <form [formGroup]="editPositionForm">
                <div class="form-row">
                  <div class="form-group col-md-4">
                    <label>Name </label>
                    <input type="text" formControlName="name" placeholder="Name">
                    <ng-container *ngIf="submitted && editPositionFormValidators.name.errors">
                      <p class="error-message-repair" *ngIf=" editPositionFormValidators.name.errors.required">
                        Name is required!
                      </p>
                    </ng-container>
                  </div>
                  <div class="form-group col-md-4">
                    <label>Position </label>
                    <input type="" formControlName="position" placeholder="Position">
                    <ng-container *ngIf="submitted && editPositionFormValidators.position.errors">
                      <p class="error-message-repair" *ngIf=" editPositionFormValidators.position.errors.required">
                        Position is required!
                      </p>
                    </ng-container>
                  </div>
                  <div class="form-group col-md-4">
                    <label>Company </label>
                    <input type="" formControlName="company" placeholder="Company">
                    <ng-container *ngIf="submitted && editPositionFormValidators.company.errors">
                      <p class="error-message-repair" *ngIf=" editPositionFormValidators.company.errors.required">
                        Company is required!
                      </p>
                    </ng-container>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-4">
                    <label>Salary </label>
                    <input type="" formControlName="salary" placeholder="Salary">
                    <ng-container *ngIf="submitted && editPositionFormValidators.salary.errors">
                      <p class="error-message-repair" *ngIf=" editPositionFormValidators.salary.errors.required">
                        Salary is required!
                      </p>
                    </ng-container>
                  </div>
                  <div class="form-group col-md-4">
                    <label>Starting Date </label>
                    <input class="input_date" [owlDateTimeTrigger]="dt3" [owlDateTime]="dt3"
                      [ngModelOptions]="{standalone: true}" placeholder="Starting Date" [(ngModel)]="selectedMoment">
                    <owl-date-time [pickerType]="'calendar'" #dt3></owl-date-time>
                    <ng-container *ngIf="submitted">
                      <p class="error-message-repair"
                        *ngIf=" selectedMoment == 0 || selectedMoment == undefined || selectedMoment == null">
                        Starting date is required!
                      </p>
                    </ng-container>
                  </div>
                  <div class="form-group col-md-4">
                    <label>Admin </label>
                    <select formControlName="admin_id" class="form-control">
                      <option *ngFor="let clt of get_all_admins_res" [value]="clt.id">
                        {{clt.userName}} </option>
                    </select>
                    <ng-container *ngIf="submitted && editPositionFormValidators.admin_id.errors">
                      <p class="error-message-repair" *ngIf=" editPositionFormValidators.admin_id.errors.required">
                        Admin is required!
                      </p>
                    </ng-container>
                  </div>
                </div>
              </form>
              <div class="form-row">
                <div class="form-group col-md-4">
                  <label>Document </label>
                  <input type="file" #file1 (change)="onImageSelected1(file1.files, $event)">
                  <!-- <p class="doc"><a href="{{imgUrl}}{{get_closing_res.doc}}" target="_blank">Show uploaded doc</a></p> -->
                  <p class="doc" *ngIf="url_type == 1"><i class="fas fa-eye"></i><a
                      (click)="showUploadedImage(showUploadedImagePopup)">Show uploaded image</a></p>
                  <p class="doc"><i class="fas fa-arrow-alt-circle-down"></i><a (click)="downloadExcel()"
                      target="_blank"><span *ngIf="url_type == 2">Download uploaded document</span><span
                        *ngIf="url_type == 1">Download uploaded image</span></a></p>
                </div>
              </div>
            </div>
            <div class="form-group right_side_admin_input">
              <button (click)="edit_closing()">Update</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #deleteModal let-modal>
  <div id="member_status" class="login_me" role="dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <button type="button" style="outline: none;" class="close close_modal" (click)="modal.dismiss('Cross click')"
        data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span> </button>
      <div class="modal-header">
        <h5 class="modal_title_2">Delete data</h5>

      </div>
      <div class="modal-body">
        <div class=" admin_member">
          <img loading="lazy" src="../../../../assets/images/logo.png">
          <p>Admin Password</p>

        </div>
        <form class="member_status_form">
          <div class="row">
            <div class="col-md-7 mx-auto">
              <div class="form-row">

              </div>
              <ng-container>
                <ng-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)" [config]="{length:4,allowNumbersOnly:true,disableAutoFocus:true
                            }"></ng-otp-input>
              </ng-container>
            </div>

            <div class="col-md-12">
              <a class="sign_in" (click)="onDeleteClosing()"> Enter </a>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #showUploadedImagePopup let-modal>
  <div id="member_status" class="login_me" role="dialog">
    <!-- Modal content-->
    <div class="modal-content show_img_content">
      <button type="button" style="outline: none;" class="close close_modal show_img_cross" (click)="close_img_modal()"
        data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span> </button>
      <!-- <div class="modal-header">
        <h5 class="modal_title_2">Delete data</h5>

      </div> -->
      <div class="modal-body show_img_body">
        <img loading="lazy" src="{{url_download_link}}">
      </div>
    </div>
  </div>
</ng-template>